import { users } from "@api/courses/stats/users/path";

export const stats = {
  users,
};
